// extracted by mini-css-extract-plugin
export default {"popupContent":"UpdateDesignWarningPopup_popupContent__SSOX7","buttonGroup":"UpdateDesignWarningPopup_buttonGroup__zyp0Z","withFrame":"UpdateDesignWarningPopup_withFrame__qoMi2"};